import axios from 'axios';
import camelCase from 'camelcase-keys';
import { ERROR_CODE } from '@src/errors/code';

let axiosClient = null;

export const createAxiosClient = (baseUrl) => {
  axiosClient = axios.create({
    baseURL: `${baseUrl}/api/v1`,
    responseType: 'json',
    timeout: 15 * 1000,
  });

  axiosClient.interceptors.request.use(
    (config) => config,
    (error) => Promise.reject(error),
  );

  axiosClient.interceptors.response.use(
    (response) => camelCase(response?.data, { deep: true }),
    (error) => {
      if (error?.response && error.response?.config?.method === 'get') {
        if (
          error.response.status === ERROR_CODE.UNAUTHORIZED ||
          error.response?.data?.code === ERROR_CODE.UNAUTHORIZED
        )
          window.location.reload();
      }
      return Promise.reject(error);
    },
  );
};

export const getApiClient = () => {
  if (!axiosClient) {
    throw new Error('API client not initialized. Call setApiBaseUrl() first.');
  }
  return axiosClient;
};

export const setAuthAccessToken = (accessToken) => {
  if (!axiosClient) {
    throw new Error('API client not initialized. Call setApiBaseUrl() first.');
  }
  axiosClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
};
